import Layout from '../components/layout/Layout';

const AboutPage = () => {
  return (
    <Layout>
      <div className="py-10">
        <div className="container-custom">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Sobre Illustra</h1>

          <div className="mt-6 space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <p>
              Illustra es una plataforma para artistas, ilustradores y creativos donde podés compartir tu trabajo, conectar con
              otras personas, y ofrecer servicios profesionales.
            </p>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Qué podés hacer</h2>
              <ul className="mt-3 space-y-2 text-sm text-gray-700 dark:text-gray-300">
                <li>- Publicar posts y explorar contenido por categorías.</li>
                <li>- Crear un perfil con tu portafolio y seguir a otros creadores.</li>
                <li>- Ofrecer servicios y gestionar órdenes con chat y archivos adjuntos.</li>
                <li>- Crear series y publicar episodios multi‑página para lectura vertical.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Nuestra misión</h2>
              <p className="mt-3 text-sm">
                Facilitar un espacio profesional y moderno donde el arte se comparta de forma simple, con herramientas que ayuden a
                los creadores a construir audiencia y a monetizar su trabajo.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutPage;

